import { Box, Typography } from "@mui/material";
import FlexBox from "../../layouts/Flexbox";
import { MeetingAttendanceActions } from "./MeetingAttendanceActions";

export type MeetingAttendanceNotificationItemProps = {
  vendorName: string;
  meetingTimeLabel: string;
  isAmbassadorAttend?: boolean;
  onConfirm?: () => void;
  onReschedule?: () => void;
};

export function MeetingAttendanceNotificationItem({
  vendorName,
  meetingTimeLabel,
  isAmbassadorAttend = false,
  onConfirm,
  onReschedule,
}: MeetingAttendanceNotificationItemProps) {
  return (
    <Box
      mb={1}
      borderRadius={1.5}
      bgcolor="background.paper"
      overflow="hidden"
      boxShadow="0 1px 2px rgba(0,0,0,0.08)"
    >
      <Box px={1.5} py={1}>
        <FlexBox alignItems="center" justifyContent="space-between" gap={1}>
          <Typography variant="caption" fontWeight={700}>
            Meeting reminder
          </Typography>
          <Box
            width={6}
            height={6}
            borderRadius="50%"
            bgcolor="primary.main"
            flexShrink={0}
          />
        </FlexBox>
        <Typography variant="caption" color="text.secondary" display="block">
          {vendorName} · {meetingTimeLabel}
        </Typography>
      </Box>

      <MeetingAttendanceActions
        isAmbassadorAttend={isAmbassadorAttend}
        onConfirm={onConfirm}
        onReschedule={onReschedule}
      />
    </Box>
  );
}
